module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/abdb9221f6fe3367ae1d899e2352d2e3.svg";